import config from '../config/constantconfig'

let OSS = require('ali-oss')

class FileOss {
  constructor () {
    this.client = new OSS({
      region: config.fileregion,
      accessKeyId: config.fileaccessKeyId,
      accessKeySecret: config.fileaccessKeySecret,
      bucket: config.filebucket
    })
  }

  async multipartUpload (objName, localfile, fun) {
    try {
      let result = await this.client.multipartUpload(objName, localfile, {
        progress: fun
      })

      let resultinfo = {
        size: result.res.size,
        rt: result.res.rt,
        url: result.name,
        result: result
      }
      return new Promise((resolve, reject) => {
        resolve(resultinfo)
      })
    } catch (e) {
      // 捕获超时异常
      if (e.code === 'ConnectionTimeoutError') {
      }
    }
  }

  async copy (sourcePath, targetpath) {
    try {
      let result = await this.client.copy(targetpath, sourcePath)
      console.log(result)
      if (result && result.res.status === 200 && result.res.statusCode === 200) {
        console.log(result)
      }
    } catch (e) {

    }
  }
}

class PicOss extends FileOss {
  constructor () {
    super()
    this.client = new OSS({
      region: config.region,
      accessKeyId: config.accessKeyId,
      accessKeySecret: config.accessKeySecret,
      bucket: config.bucket
    })
  }
}

class VideoOss extends FileOss {
  constructor () {
    super()
    this.client = new OSS({
      region: config.videoregion,
      accessKeyId: config.videoaccessKeyId,
      accessKeySecret: config.videoaccessKeySecret,
      bucket: config.videobucket
    })
  }
}

export default {
  VideoOss: VideoOss,
  PicOss: PicOss,
  FileOss: FileOss
}
